export default __webpack_public_path__ + "static/0134-cca5b6a9829f8ba09d0656f214775b87.png";